/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { MessageCenter } from "utils";

import Button, { ButtonContainer } from 'components/Button';

import {
  EntityInformationSection,
  HierarchySection,
  GeneralSection
} from './sections/index';

export default function BasicInformation({
  formikProps,
  formikRef,
  idProduct,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  hierarchyGroup,
  setHierarchyGroup,
  teamsGroup,
  SECTIONS,
  refQuestionnaireSent,
  submitFunction,
}) {
  const mc = new MessageCenter();

  return (
    <>
      <EntityInformationSection.components.RenderSection
        formikProps={formikProps}
        formikRef={formikRef}
        idProduct={idProduct}
        globalQuestionnaire={globalQuestionnaire}
        setGlobalQuestionnaire={setGlobalQuestionnaire}
      />

      <HierarchySection.components.RenderSection
        formikProps={formikProps}
        formikRef={formikRef}
        idProduct={idProduct}
        globalQuestionnaire={globalQuestionnaire}
        setGlobalQuestionnaire={setGlobalQuestionnaire}
        hierarchyGroup={hierarchyGroup}
        setHierarchyGroup={setHierarchyGroup}
      />
      <ButtonContainer style={{ justifyContent: 'end' }}>
        <Button
          type="button"
          primary
          onClick={async () => {
            GeneralSection.events.handleSave({
              questionnaire: globalQuestionnaire,
              formikRef,
              mc,
              SECTIONS,
              teamsGroup,
              values: formikProps.values,
              refQuestionnaireSent,
              submitFunction,
            })
          }}
        >
          SAVE & REFRESH
        </Button>
      </ButtonContainer>
    </>
  );
}